import React from "react";
import ReactDOM from "react-dom/client";
import { HeroUIProvider } from "@heroui/react";

import App from "./App.tsx";
import { OfflineBanner } from "./components/OfflineBanner";
import { ServiceWorkerRegistration } from "./components/ServiceWorkerRegistration";
import { NetworkMonitor } from "./components/NetworkMonitor";
import ThemeProvider from "./components/ThemeProvider";
import "./index.css";

// Adiciona um evento para detectar quando o service worker estiver pronto
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.ready.then(() => {
      console.log('Service Worker está pronto para uso!');
    });
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <HeroUIProvider>
        <main className="text-foreground bg-background">
          <ServiceWorkerRegistration />
          <NetworkMonitor />
          <OfflineBanner />
          <App />
        </main>
      </HeroUIProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
